import gql from 'graphql-tag';

export default gql`
  mutation ccRecordingRequest($action: String!) {
    ccRecordingRequest(action: $action) {
      result
      errors
    }
  }
`;
